module.exports = __webpack_public_path__ + "media/images/android-chrome-192x192-f1fef3c3f82d389f395a672c4919b28b.png";